export default __webpack_public_path__ + "static/media/file.a56ff68a.png";